var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "toolbar-overlay",
        on: { click: _vm.onToolbarModalClick },
      },
      _vm.listeners
    ),
    [
      _c(
        "div",
        {
          ref: "toolbar",
          staticClass: "toolbar-component",
          class: _vm.toolbarClasses,
          style: _vm.toolbarStyles,
          on: {
            mousedown: _vm.onToolbarComponentMouseDown,
            touchstart: _vm.onToolbarComponentMouseDown,
          },
        },
        [
          _c("div", { staticClass: "toolbar-handler" }),
          _vm.title
            ? _c("div", { staticClass: "toolbar-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "toolbar-body",
              class: _vm.computedBodyClasses,
              style: _vm.bodyStyles,
            },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }